import React, { useCallback, useMemo } from 'react';
import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import IconBackGround from '../../common/iconBackGround';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { GAME_SPEED_TYPES } from '../../../core/constants/gameConstants';
import { gameStore } from '../../../store/gameStore';
import { gameDrawer } from '../../../services/gameDrawer';
import { isMobile } from '../../../core/helpers/isMobile';

const GameSpeed = observer(({ x = 0, y = 0 }) => {
  const { gameSpeedType, setGameSpeedType } = bettingPartStore;
  const { setGameFastSpeed, setGameTurboSpeed, setGameStandardSpeed } = gameStore;
  const { standardSpeed, fastSpeed, turboSpeed } = getGameImages();

  const handleChangeGameSpeed = useCallback(() => {
    let gameNextSpeedType = GAME_SPEED_TYPES.standard;
    if (gameSpeedType === GAME_SPEED_TYPES.standard) {
      gameNextSpeedType = GAME_SPEED_TYPES.fast;
    } else if (gameSpeedType === GAME_SPEED_TYPES.fast) {
      gameNextSpeedType = GAME_SPEED_TYPES.turbo;
    }
    setGameSpeedType(gameNextSpeedType);
    gameDrawer.updateReelAnimationSpeed();
  }, [gameSpeedType, setGameFastSpeed, setGameSpeedType, setGameStandardSpeed, setGameTurboSpeed]);

  const gameSpeedIcons = useMemo(() => {
    return {
      [GAME_SPEED_TYPES.standard]: standardSpeed,
      [GAME_SPEED_TYPES.fast]: fastSpeed,
      [GAME_SPEED_TYPES.turbo]: turboSpeed,
    };
  }, [standardSpeed, fastSpeed, turboSpeed]);

  return (
    <IconBackGround y={y} x={x} handleSelect={handleChangeGameSpeed} hasSelectedState={false}>
      <Sprite
        texture={gameSpeedIcons[gameSpeedType]}
        anchor={0.5}
        scale={isMobile() ? 0.77 : 0.5}
      />
    </IconBackGround>
  );
});
export default GameSpeed;
